import { createDefaultTyrann } from '@apis/common';
import * as t from 'io-ts';
import * as h from 'tyrann-io/src/helpers';

export const accountBody = t.type({
  email: t.string,
});

export const accountResponseBody = t.type({
  detail: t.string,
});

export type AccountBody = t.TypeOf<typeof accountBody>;

export const forgetPasswordApis = createDefaultTyrann({
  '/password/reset/': {
    post: {
      body: accountBody,
      response: {
        200: accountResponseBody,
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
});
